(function($){
    if($('#order_review').length > 0){
        var int = setInterval(function(){
            if($('#shipping_method_0_flexible_shipping_single17').prop('checked') == true){
                $('#payment_method_pay_by_paynow_pl_paywall').prop('checked', false);
                $('.payment_method_pay_by_paynow_pl_paywall').hide();
            }
            else{
                $('.payment_method_pay_by_paynow_pl_paywall').show();
            }
            // if($('body .woocommerce-checkout-payment:first-of-type li:not([style])').length == 1){
            //     $('body .woocommerce-checkout-payment:first-of-type li:not([style])').find('input').prop('checked', 'checked');
            //     $('body .woocommerce-checkout-payment:first-of-type li:not([style])').addClass('tester');
            // }
            // console.log($('body .woocommerce-checkout-payment:first-of-type li:not([style])').length);
            // if($('#payment_method_pay_by_paynow_pl_paywall').prop('checked') == true){
            //     $('#shipping_method_0_flexible_shipping_single17').prop('checked', false);
            //     $('#shipping_method_0_flexible_shipping_single17').closest('li').hide();
            //     // $('#shipping_method li:first-of-type').click();
            // }
            // else{
            //     $('#shipping_method_0_flexible_shipping_single17').closest('li').show();
            // }
        }, 300)
    }
})(jQuery)